import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Tokens } from '../../api/swap'
import formatLongNumber from '../../utils/formatLongNumber'
import TokLogo from '../../assets/images/logo.svg'
import thousandsSeparator from '../../utils/thousandsSeparator'

const Tips = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;

  border-radius: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 0;
  border-right: 0;
  font-family: 'Inter var', sans-serif;
  gap: 8px;
  .title {
    display: none;
  }
  @media (max-width: 768px) {
    /* position: fixed; */
    /* margin-top: 44px; */
    height: 36px;
    font-size: 12px;
    border: none;
    z-index: 2;
    /* display: none; */
    width: 100%;
    background: #4e5969;
    .title {
      display: block;
    }
    img {
      display: none;
    }
    /* display: none; */
  }
`
export default function Index() {
  const [price, setPrice] = useState('')
  const [increase, setIncrease] = useState('')
  const [d1, setD1] = useState('')
  function addBeforeDash(str) {
    if (str > 0) {
      return '+' + str
    } else {
      return str.toString()
    }
    // return str.toString()
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await Tokens()
        data.find(item => {
          if (item.symbol === 'DOR') {
            // setTokData(TokData)
            setPrice(item?.price)
            setD1(item?.['d1'])
            setIncrease(thousandsSeparator(addBeforeDash(formatLongNumber(item?.['d1'] * 100, 2))) + '%')
          }
        })
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [])

  return (
    <Tips>
      <span className="title">DOR Price:</span>
      <img src={TokLogo} width={24} />¥{thousandsSeparator(price)}
      <span
        style={{
          color: d1 < 0 ? '#E65262' : '#13a98d'
        }}
      >
        ({increase || '0.00%'})
      </span>
    </Tips>
  )
}
